import type { inputSettings } from "./inputSettings";

/** Legacy upload keys consolidated onto `file`. */
const INPUT_KEY_ALIASES: Record<string, keyof typeof inputSettings> = {
    "fixed-activity-selection": "ms-adl-selection",
    "fixed-ratings-list": "ms-adl-ratings-list",
    "document-upload": "file",
};

export function resolveInputKey(inputKey: string): keyof typeof inputSettings {
    return (INPUT_KEY_ALIASES[inputKey] ?? inputKey) as keyof typeof inputSettings;
}

export const MS_ADL_SLUGS = ["ms-adl", "fixed-activity-difficulty"] as const;

export const MS_ADL_SELECTION_INPUT_KEYS = ["ms-adl-selection", "fixed-activity-selection"] as const;

export const MS_ADL_RATINGS_LIST_INPUT_KEYS = ["ms-adl-ratings-list", "fixed-ratings-list"] as const;

export function isMsAdlSlug(slug: string | null | undefined): boolean {
    return slug != null && (MS_ADL_SLUGS as readonly string[]).includes(slug);
}

export function isMsAdlSelectionInputKey(inputKey: string | null | undefined): boolean {
    return inputKey != null && (MS_ADL_SELECTION_INPUT_KEYS as readonly string[]).includes(inputKey);
}

export function isMsAdlRatingsListInputKey(inputKey: string | null | undefined): boolean {
    return inputKey != null && (MS_ADL_RATINGS_LIST_INPUT_KEYS as readonly string[]).includes(inputKey);
}
